import { CircularProgress, IconButton, IconButtonProps } from "@mui/material";
import { Trash } from "@phosphor-icons/react";
import { APP_COLORS } from "../../../enums";

const DEFAULT_SX = { p: 0, verticalAlign: "middle" } as const;

export interface DeleteIconButtonProps extends Omit<IconButtonProps, "children"> {
  iconSize?: number;
  loading?: boolean;
}

export default function DeleteIconButton({
  iconSize = 20,
  loading = false,
  sx,
  size = "small",
  disabled,
  ...props
}: DeleteIconButtonProps) {
  return (
    <IconButton
      aria-label="Delete"
      size={size}
      disabled={disabled || loading}
      sx={{ ...DEFAULT_SX, ...sx }}
      {...props}
    >
      {loading ? (
        <CircularProgress size={iconSize} sx={{ color: APP_COLORS.error }} />
      ) : (
        <Trash size={iconSize} color={APP_COLORS.error} />
      )}
    </IconButton>
  );
}
